import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Copy = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/copy">
        <g id="copy">
          <path
            id="Vector"
            d="M7.3987 15.1667H4.5987C1.99203 15.1667 0.832031 14.0067 0.832031 11.4V8.60004C0.832031 5.99337 1.99203 4.83337 4.5987 4.83337H7.3987C10.0054 4.83337 11.1654 5.99337 11.1654 8.60004V11.4C11.1654 14.0067 10.0054 15.1667 7.3987 15.1667ZM4.5987 5.83337C2.53203 5.83337 1.83203 6.53337 1.83203 8.60004V11.4C1.83203 13.4667 2.53203 14.1667 4.5987 14.1667H7.3987C9.46537 14.1667 10.1654 13.4667 10.1654 11.4V8.60004C10.1654 6.53337 9.46537 5.83337 7.3987 5.83337H4.5987Z"
          />
          <path
            id="Vector_2"
            d="M11.3987 11.1667H10.6654C10.392 11.1667 10.1654 10.94 10.1654 10.6667V8.60004C10.1654 6.53337 9.46536 5.83337 7.3987 5.83337H5.33203C5.0587 5.83337 4.83203 5.60671 4.83203 5.33337V4.60004C4.83203 1.99337 5.99203 0.833374 8.5987 0.833374H11.3987C14.0054 0.833374 15.1654 1.99337 15.1654 4.60004V7.40004C15.1654 10.0067 14.0054 11.1667 11.3987 11.1667ZM11.1654 10.1667H11.3987C13.4654 10.1667 14.1654 9.46671 14.1654 7.40004V4.60004C14.1654 2.53337 13.4654 1.83337 11.3987 1.83337H8.5987C6.53203 1.83337 5.83203 2.53337 5.83203 4.60004V4.83337H7.3987C10.0054 4.83337 11.1654 5.99337 11.1654 8.60004V10.1667Z"
          />
        </g>
      </g>
    </svg>
  );
};

Copy.displayName = 'Copy';
